import React from 'react';
import type { HeadlineSegment } from '../../types/landing';
type LandingHeroProps = {
  eyebrow: string;
  headline: HeadlineSegment[];
  intro: string;
};
export function LandingHero({
  eyebrow,
  headline,
  intro
}: LandingHeroProps) {
  return <section className="mx-auto max-w-3xl px-6 pt-8 text-center md:pt-10" data-id="element-23" data-mp="2sc90b46xcist">
      <p className="font-display text-lg italic text-ink/80" data-id="element-24" data-mp="2xak5v2q6s758">{eyebrow}</p>
      <h1 className="mt-3 font-display text-3xl font-medium uppercase leading-[1.15] tracking-[0.04em] text-ink md:text-[2.6rem]" data-id="element-25" data-mp="3kyk04cmpifok">
        {headline.map((segment, i) => {
        if (segment.emphasis === 'underline') {
          return <span key={i} className="underline decoration-1 underline-offset-[6px]" data-id="element-26" data-mp="3b0nqxqdbxut3">
                {segment.text}
              </span>;
        }
        if (segment.emphasis === 'strong') {
          return <strong key={i} className="font-bold underline decoration-2 underline-offset-[6px]" data-id="element-27" data-mp="24ktpso4zuv6h">
                {segment.text}
              </strong>;
        }
        return <span key={i} data-id="element-28" data-mp="2tema0eoz3gkz" data-mpi={i}>{segment.text}</span>;
      })}
      </h1>
      <p className="mx-auto mt-5 max-w-xl font-body text-[15px] leading-relaxed text-ink/80" data-id="element-29" data-mp="37dm3bznfkjnh">
        {intro}
      </p>
    </section>;
}